export class NiceSimRegistrationToken {
  static INiceSimRegistrationRepository = Symbol(
    "INiceSimRegistrationRepository",
  );
  static NiceSimRegistrationViewModel = Symbol("NiceSimRegistrationViewModel");
  static NiceSimRegistrationUseCase = Symbol("NiceSimRegistrationUseCase");
}
